"use client";

import { useState } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export default function Gallery({ images }) {
  console.log(images);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const openLightbox = (index) => setSelectedImageIndex(index);
  const closeLightbox = () => setSelectedImageIndex(null);
  const goToPrevious = () =>
    setSelectedImageIndex((prev) =>
      prev === null || prev === 0 ? images.length - 1 : prev - 1
    );
  const goToNext = () =>
    setSelectedImageIndex((prev) =>
      prev === null || prev === images.length - 1 ? 0 : prev + 1
    );

  return (
    <>
      <div className="my-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg cursor-pointer transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg"
              onClick={() => openLightbox(index)}
            >
              <div className="aspect-w-16 aspect-h-9">
                <img
                  src={image}
                  alt={image}
                  layout="fill"
                  objectFit="cover"
                  className="transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-start p-4">
                <p className="text-white text-sm font-medium">{image.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Dialog
        open={selectedImageIndex !== null}
        onClose={closeLightbox}
        PaperProps={{
          style: { background: "none", boxShadow: "none" },
        }}
      >
        <DialogContent className="max-w-6xl bg-transparent border-none overflow-hidden !no-scrollbar">
          {selectedImageIndex !== null && (
            <div className="relative aspect-video">
              <img
                src={images[selectedImageIndex]}
                alt={images[selectedImageIndex]}
                className="h-auto w-auto"
              />
              <button
                onClick={goToPrevious}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/10 hover:bg-white/20 rounded-full p-2 transition-colors duration-200"
                aria-label="Previous image"
              >
                <ChevronLeft className="w-6 h-6 text-white" />
              </button>
              <button
                onClick={goToNext}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/10 hover:bg-white/20 rounded-full p-2 transition-colors duration-200"
                aria-label="Next image"
              >
                <ChevronRight className="w-6 h-6 text-white" />
              </button>
              <button
                onClick={closeLightbox}
                className="absolute top-2 right-2 bg-white/10 hover:bg-white/20 rounded-full p-2 transition-colors duration-200"
                aria-label="Close lightbox"
              >
                <span className="text-white font-medium">
                  <X />
                </span>
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
